import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { getContactDetail } from "../../../store/actions"
import TitleDropdowns from "components/dropdowns/Other/titleDropdowns"
import OtherDropdowns from "components/dropdowns/Other/OtherDropdowns"
import SaveButton from "components/buttons/save"
import RsLink from "components/buttons/rsLink"
import { Row, Col, FormGroup, Label } from "reactstrap"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { API_URL } from 'helpers/app_url';
import axios from "axios"
import { updateContact } from "../../../store/actions"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import PhoneInputField from "components/dropdowns/PhoneInputField"
import SafeField from "helpers/SafeField";

class ContactEdit extends Component {

  constructor(props) {
    super(props)
    this.state = { contactClassification: [] }
    this.handleSubmit = this.handleSubmit.bind(this);
  }


  componentDidMount() {

    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = 'Bearer ' + token;

    axios.get(`${API_URL}ContactClassification/allforagent?agentId=` + localStorage.getItem("userId"), {
      params: {
      }, headers: { Authorization: str }
    })
      .then(res => {
        this.setState({ contactClassification: res.data });
      })
  }

  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;

        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };
        const streetNumber = getComponent(['street_number']);
        const route = getComponent(['route']);
        const city = getComponent(['locality', 'political']);
        const province = getComponent(['administrative_area_level_1', 'political']);
        const postalCode = getComponent(['postal_code']);
        const country = getComponent(['country', 'political']);

        const modifiedAddress = `${streetNumber} ${route}`;
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        setFieldValue(`fullAddress`, place.formatted_address);
        setFieldValue(`addressLine1`, modifiedAddress);
        setFieldValue(`addressLine2`, '');
        setFieldValue(`city`, city);
        setFieldValue(`province`, province);
        setFieldValue(`postal`, postalCode);
        setFieldValue(`country`, country);
        setFieldValue(`longitude`, longitude);
        setFieldValue(`latitude`, latitude);
      })
      .catch(error => console.error('Error', error));
  };

handleSubmit = async (values, actions) => {
  const { closed } = this.props;
  const { onGetContactDetail } = this.props;
  const payload = {
    id: values.id,
    contactId: values.contactId,
    agentId: parseInt(localStorage.getItem("userId"), 10),
    firstName: values.firstName,
    lastName: values.lastName,
    contactStatusId: parseInt(values.contactStatusId || 0, 10),
    contactTypeId: parseInt(values.contactTypeId || 0, 10),
    contactSourceId: parseInt(values.contactSourceId || 0, 10),
    email: values.email,
    phone: values.phone,
    phoneExt: values.phoneExt,
    officePhone: values.officePhone,
    mobile: values.mobile,
    addressId: parseInt(values.addressId || 0, 10),
    fullAddress: values.fullAddress,
    addressLine1: values.addressLine1,
    addressLine2: values.addressLine2,
    nearestIntersection: values.nearestIntersection,
    city: values.city,
    province: values.province,
    postal: values.postal,
    country: values.country,
    longitude: values.longitude,
    latitude: values.latitude,
    organizationName: values.organizationName,
    jobTitle: values.jobTitle, 
    lastContact: values.lastContact,
    isVendor: !!values.isVendor,
    isClient: !!values.isClient,
    isActive: !!values.isActive,
    referedById: values.referedById,
    referedBy: values.referedBy,
    referralCode: values.referralCode,
    howOffenContact: values.howOffenContact || '',
    notes: values.notes,
    title: values.title,
    isInvestor: !!values.isInvestor,
    connectFrequency: values.connectFrequency,
    maritalStatus: parseInt(values.maritalStatus || 0, 10),
    secondaryPhone: values.secondaryPhone,
    officePhoneExt: values.officePhoneExt,
    contactClassificationId: parseInt(values.contactClassificationId || 0, 10),
  };

  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;
  const authHeader = `Bearer ${token}`;

  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = await axios.put(`${API_URL}Contact/`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: authHeader,
      },
    });
    if ( response.data?.success) {
      toast.update(toastId, {
        render: "Updated successfully.",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
        onGetContactDetail(values.contactId)
        closed();
    } else {
      const errorMsg =
        response.data?.message ||
        response.data?.validationErrors?.[0] ||
        "Failed to update contact. Please try again.";
      toast.update(toastId, {
        render: errorMsg,
        type: "warning",
        isLoading: false,
        autoClose: 3000,
      });
    }
  } catch (error) {
    toast.update(toastId, {
      render: error.response?.data?.message || "Error occurred while updating. Please try again.",
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
  }
};


  render() {
    const { closed, contactDetail } = this.props;
    return (
      <React.Fragment>
        {/* <ToastContainer autoClose={2000} /> */}
        <Formik
          enableReinitialize={true}
          initialValues={{
            id: contactDetail.id,
            contactId: contactDetail.contactId,
            agentId: parseInt(localStorage.getItem("userId")),
            firstName: contactDetail.firstName,
            lastName: contactDetail.lastName,
            contactStatusId: parseInt(contactDetail.contactStatusId),
            contactTypeId: parseInt(contactDetail.contactTypeId),
            contactSourceId: parseInt(contactDetail.contactSourceId),
            email: contactDetail.email,
            phone: contactDetail.phone,
            phoneExt: contactDetail.phoneExt,
            officePhone: contactDetail.officePhone,
            mobile: contactDetail.mobile,
            addressId: contactDetail.addressId,
            fullAddress: contactDetail?.contactAddress?.fullAddress,
            addressLine1: contactDetail?.contactAddress?.addressLine1,
            addressLine2: contactDetail?.contactAddress?.addressLine2,
            nearestIntersection: contactDetail?.contactAddress?.nearestIntersection,
            city: contactDetail?.contactAddress?.city,
            province: contactDetail?.contactAddress?.province,
            postal: contactDetail?.contactAddress?.postal,
            country: contactDetail?.contactAddress?.country,
            longitude: contactDetail?.contactAddress?.longitude,
            latitude: contactDetail?.contactAddress?.latitude,
            organizationName: contactDetail.organizationName,
            jobTitle: contactDetail.jobTitle,
            lastContact: contactDetail.lastContact,
            isVendor: contactDetail.isVendor,
            isClient: contactDetail.isClient,
            isActive: contactDetail.isActive,
            referedById: contactDetail.referedById,
            referedBy: contactDetail.referedBy,
            referralCode: contactDetail.referralCode,
            howOffenContact: contactDetail.howOffenContact,
            notes: contactDetail.notes,
            //title: contactDetail.title,
            isInvestor: contactDetail.isInvestor,
            connectFrequency: contactDetail.connectFrequency,
            maritalStatus: contactDetail.maritalStatus,
            secondaryPhone: contactDetail.secondaryPhone,
            officePhoneExt: contactDetail.officePhoneExt,
            contactClassificationId: contactDetail.contactClassificationId
            //lastContact: new Date()

          }}
          validationSchema={Yup.object().shape({
            // title: Yup.string().required(
            //   "This is required"
            // ),
            firstName: Yup.string().required(
              "Please Enter Your First Name"
            ),
            lastName: Yup.string().required(
              "Please Enter Your Last Name"
            ),
            email: Yup.string().email("Must be a valid Email")
              .max(255)
              .required("Email is required"),
            mobile: Yup.string().required("Email is required"),
            //phone: Yup.string().matches(/(?:\(?\+\d{2}\)?\s*)?\d+(?:[ -]*\d+)*$/, 'Enter number is not valid'),
            contactClassificationId: Yup.string().required("This is required")


          })}

          onSubmit={this.handleSubmit}
        >
          {({ errors, touched, handleChange, values, setFieldValue }) => (
        
               <Form
                          className="needs-validation"
                        >
            
            
                          <Row>
                            {/* <Col md="3">
                              <FormGroup className="mb-3">
                                <Label htmlFor="lastContact">
                                  {this.props.t("Last Contact ")}
                                </Label>
                                <Flatpickr
                                  className={
                                    "form-control" +
                                    (errors.lastContact && touched.lastContact
                                      ? " is-invalid"
                                      : "")
                                  }
                                  placeholder=""
            
                                  onChange={(value) => setFieldValue('lastContact', value[0])}
                                  options={{
                                    altInput: true,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d"
                                  }}
                                />
            
            
                              </FormGroup>
                            </Col> */}
                            {/* <Col md="3">
                            <FormGroup className="mb-3">
                                <Label htmlFor="title">
                                  {this.props.t("Title *")}
                                </Label>
                                <SafeField
                                  name="title"
                                  type="text"
                                  onChange={handleChange}
                                  className={
                                    "form-control" +
                                    (errors.title && touched.title
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="title"
                                />
                                <ErrorMessage
                                  name="title"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                             
            
                            </Col> */}
                            <Col md="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="firstName">
                                  {this.props.t("First Name *")}
                                </Label>
                                <SafeField
                                  name="firstName"
                                  type="text"
                                  onChange={handleChange}
                                  className={
                                    "form-control" +
                                    (errors.firstName && touched.firstName
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="firstName"
                                />
                                <ErrorMessage
                                  name="firstName"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
            
                            <Col md="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="lastName">
                                  {this.props.t("Last Name *")}
                                </Label>
                                <SafeField
                                  name="lastName"
                                  type="text"
                                  onChange={handleChange}
                                  className={
                                    "form-control" +
                                    (errors.lastName && touched.lastName
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="lastName"
                                />
                                <ErrorMessage
                                  name="lastName"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                            <Col md="4">
                              <OtherDropdowns
                                name="maritalStatus"
                                label="Marital status"
                                fieldName="Lead:Marital Status"
                              />
                            </Col>
                            <Col md="3">
                              <FormGroup className="mb-3">
                                <Label htmlFor="contactClassificationId">
                                  Classification *
                                </Label>
                                <SafeField as="select" name="contactClassificationId"
                                  className={
                                    "form-control" +
                                    (errors.contactClassificationId && touched.contactClassificationId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={handleChange}>
                                  <option value="">Select</option>
                                  {
                                    this.state.contactClassification
                                      .map(contactClassification =>
                                        <option key={contactClassification.id} value={contactClassification.id}>{contactClassification.contactClassificationTitle}</option>
                                      )
                                  }
                                </SafeField>
                                <ErrorMessage
                                  name="contactClassificationId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
            
                            <Col md="9">
                              <FormGroup className="mb-3">
                                <Label htmlFor="streetName">
                                  {this.props.t("Address")}
                                </Label>
            
            
                                <PlacesAutocomplete
                                  value={values.fullAddress}
                                  onChange={(value) => setFieldValue('fullAddress', value)}
                                  onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                                >
                                  {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                    <div>
                                      <input
                                        {...getInputProps({
                                          placeholder: 'Enter Address...',
                                          className: 'form-control',
            
                                        })}
                                      />
                                      <div className="">
                                        {loading ? <div>Loading...</div> : null}
            
                                        {suggestions.map((suggestion, i) => {
                                          const className = suggestion.active
                                            ? 'suggestion-item--active'
                                            : 'suggestion-item';
                                          const style = suggestion.active
                                            ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                            : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };
            
                                          return (
                                            <div
                                              key={i}
                                              {...getSuggestionItemProps(suggestion, {
                                                style,
                                              })}
                                            >
                                              {suggestion.description}
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  )}
                                </PlacesAutocomplete>
            
                              </FormGroup>
                            </Col>
                             <Col md="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="connectFrequency" >
                                  {this.props.t("Connect Frequency")}
                                </Label>
                                <SafeField as="select" name="connectFrequency"
            
                                  className={
                                    "form-control" +
                                    (errors.connectFrequency && touched.connectFrequency
                                      ? " is-invalid"
                                      : "")
                                  }>
                                  <option value="">Select</option>
                                  <option value="Monthly">Monthly</option>
                                  <option value="Quarterly">Quarterly</option>
                                  <option value="Semi-annual">Semi-annual</option>
                                  <option value="Annual">Annual</option>
            
                                </SafeField>
                                <ErrorMessage
                                  name="connectFrequency"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                             <Col md="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="isVendor" >
                                  {this.props.t("Is Vendor ")}
                                </Label>
                                <SafeField as="select" name="isVendor"
            
                                  className={
                                    "form-control" +
                                    (errors.isVendor && touched.isVendor
                                      ? " is-invalid"
                                      : "")
                                  }>
                                  <option value="">Select</option>
                                  <option value={true}>Yes</option>
                                  <option value={false}>No</option>
            
                                </SafeField>
                                <ErrorMessage
                                  name="isVendor"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                            <Col md="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="isInvestor" >
                                  {this.props.t("Is Investor ")}
                                </Label>
                                <SafeField as="select" name="isInvestor"
            
                                  className={
                                    "form-control" +
                                    (errors.isInvestor && touched.isInvestor
                                      ? " is-invalid"
                                      : "")
                                  }>
                                  <option value="">Select</option>
                                  <option value={true}>Yes</option>
                                  <option value={false}>No</option>
            
                                </SafeField>
                                <ErrorMessage
                                  name="isInvestor"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                            <Col md="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="email">
                                  {this.props.t("Email *")}
                                </Label>
                                <SafeField
                                  name="email"
                                  type="text"
            
                                  onChange={handleChange}
                                  className={
                                    "form-control" +
                                    (errors.email && touched.email
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="email"
                                />
                                <ErrorMessage
                                  name="email"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
            
                            <Col md="4">
                                <PhoneInputField
                                  label="Mobile"
                                  name="mobile"
                                  value={values.mobile}
                                  setFieldValue={setFieldValue}
                                  error={errors.mobile}
                                  touched={touched.mobile}
                                  country="ca"
                                  required={true}
                                />
                             
                            </Col>
                            <Col md="4">
                             <PhoneInputField
                                  label="Secondary Phone"
                                  name="phone"
                                  value={values.phone}
                                  setFieldValue={setFieldValue}
                                  error={errors.phone}
                                  touched={touched.phone}
                                  country="ca"
                                  required={false}
                                />
                              {/* <FormGroup className="mb-3">
                                <Label htmlFor="phone">
                                  {this.props.t("Secondary Phone")}
                                </Label>
                                <SafeField
                                  name="phone"
                                  type="text"
            
                                  onChange={handleChange}
                                  className={
                                    "form-control" +
                                    (errors.phone && touched.phone
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="phone"
                                />
                                <ErrorMessage
                                  name="phone"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup> */}
                            </Col>
                            {/* <Col md="2">
                              <FormGroup className="mb-3">
                                <Label htmlFor="phoneExt">
                                  {this.props.t("Ext")}
                                </Label>
                                <SafeField
                                  name="phoneExt"
                                  type="text"
                                  //value={values.phone}
                                  onChange={handleChange}
                                  className={
                                    "form-control" +
                                    (errors.phoneExt && touched.phoneExt
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="phoneExt"
                                />
                                <ErrorMessage
                                  name="phoneExt"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col> */}
                           
                            {/* <Col md="3">
                              <FormGroup className="mb-3">
                                <Label htmlFor="isClient" >
                                  {this.props.t("Is Client ")}
                                </Label>
                                <SafeField as="select" name="isClient"
            
                                  className={
                                    "form-control" +
                                    (errors.isClient && touched.isClient
                                      ? " is-invalid"
                                      : "")
                                  }>
                                  <option value="">Select</option>
                                  <option value={true}>Yes</option>
                                  <option value={false}>No</option>
            
                                </SafeField>
                                <ErrorMessage
                                  name="isClient"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col> */}
                           
            
            
            
            
                            <Col md="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="organizationName">
                                  {this.props.t("Employer")}
                                </Label>
                                <SafeField
                                  name="organizationName"
                                  type="text"
                                  className={
                                    "form-control" +
                                    (errors.organizationName && touched.organizationName
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="organizationName"
                                />
                                <ErrorMessage
                                  name="organizationName"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                            <Col md="3">
                              <FormGroup className="mb-3">
                                <Label htmlFor="jobTitle">
                                  {this.props.t("Job title")}
                                </Label>
                                <SafeField
                                  name="jobTitle"
            
                                  type="text"
            
                                  className="form-control"
            
                                  id="jobTitle"
                                />
                              </FormGroup>
                            </Col>
                            <Col md="3">
                            <PhoneInputField
                                  label="Office phone"
                                  name="officePhone"
                                  value={values.officePhone}
                                  setFieldValue={setFieldValue}
                                  error={errors.officePhone}
                                  touched={touched.officePhone}
                                  country="ca"
                                  required={false}
                                />
                              {/* <FormGroup className="mb-3">
                                <Label htmlFor="officePhone">
                                  {this.props.t("Office phone")}
                                </Label>
                                <SafeField
                                  name="officePhone"
            
                                  type="text"
            
                                  className="form-control"
            
                                  id="officePhone"
                                />
            
                              </FormGroup> */}
                            </Col>
                            <Col md="2">
                              <FormGroup className="mb-3">
                                <Label htmlFor="officePhoneExt">
                                  {this.props.t("Ext ")}
                                </Label>
                                <SafeField
                                  name="officePhoneExt"
            
                                  type="text"
            
                                  className="form-control"
            
                                  id="officePhoneExt"
                                />
            
                              </FormGroup>
                            </Col>
                          </Row>
                          <div><SaveButton>{this.props.t("Save")}</SaveButton>{" "} <RsLink onClick={closed}>Close</RsLink></div>
            
            
            
            
                        </Form>
          )}
        </Formik>

      </React.Fragment >
    )
  }
}

ContactEdit.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  onGetContactDetail:PropTypes.func,
  contactDetail: PropTypes.object,
  closed: PropTypes.object,
  history: PropTypes.object,
  error: PropTypes.any,
}

const mapDispatchToProps = dispatch => ({
      onGetContactDetail: id => dispatch(getContactDetail(id))
})
export default connect('', mapDispatchToProps)(withTranslation()(ContactEdit))
